module.exports = "md-progress-spinner {\n  width: 25px !important;\n  height: 25px !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/request-password-reset/request-password-reset.component.css
// module id = ./src/app/user/request-password-reset/request-password-reset.component.css
// module chunks = main